
  var strokeImages220lb = {
    "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-2.jpg?v=1676324403", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-2.pdf?v=1676323893" },
    "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-4_3856a327-2933-44d2-abc4-b6ae099c491a.png?v=1676325083", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-4.pdf?v=1676323893" },
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-6.png?v=1676326238", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-6.pdf?v=1676323893" },
    "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-8.png?v=1676326327", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-8.pdf?v=1676323893" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-10_9ec5f1b8-f1c3-436d-9ed5-eaf3719cef02.png?v=1676326294", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-10.pdf?v=1676323893" },
    "12": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-12.png?v=1676326351", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-12.pdf?v=1676323893" },
    "14": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-14.png?v=1676326378", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-14.pdf?v=1676323894" },
    "16": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-16.png?v=1676326398", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-16.pdf?v=1676323894" },
    "18": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-18.png?v=1676326420", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-18.pdf?v=1676323894" },
    "20": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-20.png?v=1676326459", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-20.pdf?v=1676323894" },
    "22": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-22.png?v=1676326480", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-22.pdf?v=1676323894" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12-24.png?v=1676326500", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-24.pdf?v=1676323894" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-30-1.png?v=1737654636", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-30.pdf?v=1737654392" },
    "35": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-35-1.png?v=1737654633", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-35.pdf?v=1737654392" },
    "40": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-40-1.png?v=1737654630", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-220-12v-40.pdf?v=1737654392" }
  };
  var strokeImages450lb = {
    "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-2.png?v=1676326530", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-2.pdf?v=1676417351" },
    "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-4.png?v=1676326619", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-4.pdf?v=1676417351" },
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-6.png?v=1676326708", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-6.pdf?v=1676417351" },
    "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-8.png?v=1676326730", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-8.pdf?v=1676417351" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-10.png?v=1676326750", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-10.pdf?v=1676417351" },
    "12": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-12.png?v=1676326773", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-12.pdf?v=1676417351" },
    "14": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-14.png?v=1676326799", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-14.pdf?v=1676417351" },
    "16": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-16.png?v=1676326821", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-16.pdf?v=1676417351" },
    "18": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-18.png?v=1676326844", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-18.pdf?v=1676417351" },
    "20": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-20.png?v=1676326866", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-20.pdf?v=1676417351" },
    "22": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-22.png?v=1676326897", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-22.pdf?v=1676417351" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12-24.png?v=1676326919", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-24.pdf?v=1676417351" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-30-1.png?v=1737654626", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-30.pdf?v=1737654392" },
    "35": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-35-1.png?v=1737654622", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-35.pdf?v=1737654392" },
    "40": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-40-1.png?v=1737654617", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-SD-H-450-12v-40.pdf?v=1737654392" }
  };
  jQuery(document).ready(function ($) {
  var strokeSelector = document.getElementById("strokeSelector");
  var forceSelector = document.getElementById("forceSelector");
  var strokeImage = document.getElementById("strokeImage");
  var imageLink = document.getElementById("imageLink");

  
  function updateImage() {
    var stroke = strokeSelector.value;
    var force = forceSelector.value;
    var selectedMap = force === "220" ? strokeImages220lb : strokeImages450lb;

    if (selectedMap[stroke]) {
      strokeImage.src = selectedMap[stroke].img;
      imageLink.href = selectedMap[stroke].link;
    }
  }
  function preloadImages(map) {
    Object.values(map).forEach(entry => {
      const img = new Image();
      img.src = entry.img;
    });
  }
  window.addEventListener('load', () => {
    setTimeout(() => {
      preloadImages(strokeImages220lb);
      preloadImages(strokeImages450lb);
    }, 500);
  });
  
  strokeSelector?.addEventListener("change", updateImage);
  forceSelector?.addEventListener("change", updateImage);
  




  function bindDropdownListeners() {
    const dropdownToggles = document.querySelectorAll(".dropdown-trigger");
    dropdownToggles.forEach(trigger => {
      if (!trigger.dataset.listenerAdded) {
        trigger.dataset.listenerAdded = "true";
        trigger.addEventListener("click", () => {
        const detailsSection = trigger.nextElementSibling;
        if (detailsSection) {
          detailsSection.style.transition = "max-height 0.3s ease, padding 0.3s ease";

          if (detailsSection.classList.contains("open")) {
            // Close
            detailsSection.style.maxHeight = "0px";
            detailsSection.classList.remove("open");
          } else {
            // Open
            detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
            detailsSection.classList.add("open");

            // If content includes images, re-measure once they load
            detailsSection.querySelectorAll("img").forEach(img => {
              if (!img.complete) {
                img.addEventListener("load", () => {
                  if (detailsSection.classList.contains("open")) {
                    detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
                  }
                });
              }
            });
          }
        }
      });
      }
    });
  }
  // Product tab toggle
  let lastChecked = document.querySelector("input[type='radio'][name='productTabs']");
  document.querySelectorAll("input[type='radio'][name='productTabs']").forEach(radio => {
    radio.addEventListener("click", function () {
      if (lastChecked === this) {
        this.checked = false;
        lastChecked = null;
      } else {
        lastChecked = this;
      }
    });
  });

    const contentTarget = document.querySelector(".fg-product-additional-content");
    if (contentTarget) {
      const contentObserver = new MutationObserver(() => {
        bindDropdownListeners();
        hideNearestH2Above(".site-wrapper");
        setupYouTubeThumbnails();
      });
      contentObserver.observe(contentTarget, { childList: true, subtree: true });
    }

    // Function to hide nearest <h2> above a target
    function hideNearestH2Above(selector) {
      const element = document.querySelector(selector);
      if (!element) return;

      let h2 = element.previousElementSibling;
      while (h2 && h2.tagName !== "H2") {
        h2 = h2.previousElementSibling;
      }

      if (h2) h2.style.display = "none";
    }

    
    function setupYouTubeThumbnails() {
      var youtube = document.querySelectorAll(".youtubeVideo:not([data-initialized])");
      youtube.forEach(el => {
        el.dataset.initialized = "true";
        el.addEventListener("click", function () {
          var iframe = document.createElement("iframe");
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("allow", "autoplay");
          iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");
          this.innerHTML = "";
          this.appendChild(iframe);
        });
      });
    }

    // Initial bindings
    bindDropdownListeners();
    hideNearestH2Above(".site-wrapper");
    setupYouTubeThumbnails();

  });
